import { cn } from "@/lib/utils";

export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="rise flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8">
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight">{title}</h1>
      {description && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const StatCard = ({ label, value, hint, icon: Icon, tone = "default", className, testId }) => (
  <div data-testid={testId} className={cn("surface p-6 relative overflow-hidden rise", className)}>
    {Icon && <Icon className={cn("absolute -right-3 -bottom-3 h-20 w-20 opacity-[0.07]", tone === "primary" && "text-primary")} />}
    <p className="eyebrow">{label}</p>
    <p className={cn("stat-num mt-3", tone === "primary" && "text-primary", tone === "warn" && "text-amber-600 dark:text-amber-400")}>{value}</p>
    {hint && <p className="text-xs text-muted-foreground mt-2">{hint}</p>}
  </div>
);

export const EmptyState = ({ title, description, testId = "empty-state", icon: Icon, action }) => (
  <div data-testid={testId} className="surface p-12 text-center">
    {Icon && <div className="mx-auto mb-4 h-12 w-12 rounded-2xl bg-primary/10 text-primary grid place-items-center"><Icon className="h-6 w-6" /></div>}
    <p className="font-heading text-lg font-medium">{title}</p>
    {description && <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const PageSkeleton = ({ rows = 5, cards = 0 }) => (
  <div data-testid="page-skeleton" className="animate-pulse space-y-4" aria-busy="true" aria-label="Memuat">
    <div className="h-3 w-24 rounded bg-muted" /><div className="h-8 w-72 rounded bg-muted" /><div className="h-3 w-96 max-w-full rounded bg-muted" />
    {cards > 0 && <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-4">{Array.from({ length: cards }).map((_, i) => <div key={i} className="h-28 rounded-xl bg-muted" />)}</div>}
    <div className="surface p-4 space-y-3 mt-4">{Array.from({ length: rows }).map((_, i) => <div key={i} className="h-10 rounded bg-muted" style={{ opacity: 1 - i * 0.12 }} />)}</div>
  </div>
);

export const Field = ({ label, children, hint, required }) => (
  <div className="space-y-1.5">
    <label className="text-xs font-semibold text-muted-foreground">{label}{required && <span className="text-primary"> *</span>}</label>
    {children}
    {hint && <p className="text-[11px] text-muted-foreground">{hint}</p>}
  </div>
);
